import { render, staticRenderFns } from "./ClientContactInfoCard.vue?vue&type=template&id=5da54f6a"
import script from "./ClientContactInfoCard.vue?vue&type=script&lang=js"
export * from "./ClientContactInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports